import categories from "./categories/categories";
import services from "./services/services";
import attributes from "./attributes/attributes";
import {Customer} from "../../CRUDs/entities/Customer";
import { Order } from "../../CRUDs/entities/Order";

export default {
    init() {
        categories.init();
        services.init();
        attributes.init();
        this.showHideAdditionalInfo();
        this.createCustomerEvent();
        this.initUploadAppointmentAttachmentButton();
    },

    showHideAdditionalInfo(){
        $('.service-management-commons__main-title-hide').click(function (e){
            e.preventDefault();
            let currentElement = $(this);
            currentElement.parent().siblings().toggle();
            if (currentElement.text() == 'Hide'){
                currentElement.text('Show')
            }else{
                currentElement.text('Hide');
            }
        });
    },
    createCustomerEvent: (request) => {
        $('body').on('click', '#create-customer-action', (e) => {
            const customer = new Customer();
            customer.openModal('create');
        });
    },
    initUploadAppointmentAttachmentButton(){
        $('body').on('click', '.upload-appointment-attachments',(e) => {
            let order = new Order($(e.target).data('order'))
            order.openDropZone()
        });
    },


}
